import { useState } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { uiActions } from '../../store';

import { ChamUploadButton } from '../ChamUpload/ChamUpload';
import { ChamProjectsOpenButton, ChamProjectsSaveButton } from '../ChamProjects/ChamProjects';
import PrintLink from '../PrintLink/PrintLink';

import styles from './TopMenu.module.css';

import logo from '../../logo.svg'
import closeIcon from './assets/close.svg';
import openIcon from './assets/open.svg';

export default function TopMenu({ extended,page }) {
    const dispatch = useDispatch();

    console.log('page',page)
    const sampleCart = useSelector((state) => state.visualizer.sampleCart);
    // Holds the mobile menu open/closed status
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    

    // Update mobile menu status on the hamburger icon click
    const handleMenuTriggerClick = function () {
        setIsMobileMenuOpen(status => !status);
    }

    const handleShareModalButtonClick = function () {
        dispatch(uiActions.setShareModalActive(true));
    }
    const handleHelpModalButtonClick = function () {
        dispatch(uiActions.setHelpModalActive(true));
    }

    const handleFeedbackModalButtonClick = function () {
        dispatch(uiActions.setFeedbackModalActive(true));
    }

    const handleSampleCartClick = function () {
        dispatch(uiActions.setSampleCartModalActive(true));
    }

    //  dispatch(visualizerActions.setProductDataBySeries({
    //         seriesId:8552,
    //         data:jsonData
    //       }));

    return (
        <section className={styles.topMenu}>
            <nav aria-label="Main Navigation">
                <ul className={!isMobileMenuOpen ? styles.closed : ''}>
                    <li className={styles.logo}>
                        <Link to="/" aria-label="Home">
                            <img src={logo} alt="Company Logo" />
                        </Link>
                    </li>

                    <li className={styles.menuTrigger}>
                        <button onClick={handleMenuTriggerClick} aria-expanded={isMobileMenuOpen} aria-controls="main-menu">
                            <span aria-hidden="true">
                                {!isMobileMenuOpen && <img src={openIcon} alt='open icon' />}
                                {isMobileMenuOpen && <img src={closeIcon} alt='close icon' />}
                            </span>
                        </button>
                    </li>

                    {page !== 'landing' && (
                        <>
                            <li>
                                <Link to="/">Start Over</Link>
                            </li>
                            {extended && (
                                <li>
                                    <Link to="/roomscenes" aria-label="New scene Button">New Scene</Link>
                                </li>
                            )}
{/* 
                            <li>
                                <ChamUploadButton title="Upload" className="" aria-label="Upload Button" />
                            </li> */}
                        </>
                    )}

                    <li>
                        <ChamProjectsOpenButton title="My Projects" className="" aria-label="My Projects Button" />
                    </li>

                    
                    {extended && (<>
                        {/* <li>
                            <ChamProjectsSaveButton title="Save" className="" aria-label="Save Button" />
                        </li> */}

                        {page == 'visualizer' && (
                            <li>
                                <PrintLink />
                            </li>
                        )}

                        {page !== 'landing' && (
                            <li>
                                <button type="button" onClick={handleShareModalButtonClick} aria-label="Share">
                                    <span>Share</span>
                                </button>
                            </li>
                        )}

                        <li>
                            <button type="button" onClick={handleFeedbackModalButtonClick} aria-label="Feedback">
                                <span>Feedback</span>
                            </button>
                        </li>

                        <li>
                            <button type="button" onClick={handleHelpModalButtonClick} aria-label="Share">
                                <span>Help</span>
                            </button>
                        </li>
                        {page == 'visualizer' && (
                            <li className={styles.sample}>
                                <button type="button" onClick={handleSampleCartClick} aria-label="Share">
                                    <span>Request Sample</span>
                                </button>
                            </li>
                        )}
                        {page === 'landing' && (
                            <li>
                                <Link to="/roomscenes" aria-label="Get started button">Get Started</Link>
                            </li>
                        )}
                        <li className={styles.quote}>
                            <button type="button" onClick={() => window.open('https://www.southernluxeflooring.com/start-your-project', '_blank')} aria-label="Request a Quote">
                                <span>Request a Quote</span>
                            </button>
                        </li>

                    </>

                    )}
                </ul>
            </nav>
        </section>
    );
}

